// extracted by mini-css-extract-plugin
export default {"legend":"Legend__legend___HN2JJ","item":"Legend__item___dJ8kg","label":"Legend__label___SHYrr fonts__whitney-book___cSNvy","smallCell":"Legend__smallCell___Wpfuk"};